import React from 'react';
import { Database } from 'lucide-react';

type GraphStatsProps = {
  totalEntities: number;
  totalRelationships: number;
  returnedNodes: number;
  returnedEdges: number;
  entityTypes: Array<{ type: string; count: number }>;
  documentCount: number;
};

export const GraphStats: React.FC<GraphStatsProps> = ({
  totalEntities,
  totalRelationships,
  returnedNodes,
  returnedEdges,
  entityTypes,
  documentCount,
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-t border-gray-200 text-xs text-gray-600">
      <div className="flex items-center gap-4">
        <Database className="w-3 h-3" />
        <span>{totalEntities} entities</span>
        <span>{totalRelationships} relationships</span>
        <span>{documentCount} documents</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-gray-400">
          Showing {returnedNodes} nodes, {returnedEdges} edges
        </span>
        {entityTypes.length > 0 && (
          <span className="text-gray-400">
            Types: {entityTypes.slice(0, 5).map((t) => t.type).join(', ')}
            {entityTypes.length > 5 && ` +${entityTypes.length - 5} more`}
          </span>
        )}
      </div>
    </div>
  );
};
